/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'star': {
    width: 159.88,
    height: 157.781,
    viewBox: '0 0 159.88 157.781',
    data: '<path pid="0" d="M127.89 157.771a7.983 7.983 0 01-4.43-1.33l-43.53-28.7-43.52 28.7a8.059 8.059 0 01-9.15-.19 7.853 7.853 0 01-2.97-8.56l14.69-50.874L2.34 60.569a7.822 7.822 0 01-1.73-8.611 7.991 7.991 0 017.38-4.884h43.02L72.78 4.002c2.71-5.353 11.59-5.353 14.3 0l21.77 43.072h43.02a7.981 7.981 0 017.38 4.884 7.822 7.822 0 01-1.73 8.611l-36.64 36.248 14.7 50.874a7.858 7.858 0 01-2.98 8.56 8.037 8.037 0 01-4.71 1.52zm-47.96-47.44a8.1 8.1 0 014.44 1.326l29.86 19.7-10.01-34.662a7.849 7.849 0 012.03-7.764l26.32-26.037h-28.66a8.007 8.007 0 01-7.15-4.371l-16.83-33.3-16.83 33.3a8 8 0 01-7.15 4.371H27.29l26.32 26.037a7.849 7.849 0 012.03 7.764l-10.01 34.662 29.87-19.7a8.068 8.068 0 014.43-1.326z" fill-rule="evenodd"/>'
  }
})
